import { useEffect, useState, useRef } from 'react';
import { collection, onSnapshot, doc, updateDoc, query, where, orderBy } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { signInWithEmailAndPassword, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { db, functions, auth as firebaseAuth } from '../firebase';

function printCommandeWeb(commande) {
  const esc = (s) => String(s ?? '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  const fmtP = (n) => Number(n).toFixed(2).replace('.', ',') + ' \u20ac';
  const fmtH = (ts) => {
    if (!ts) return '';
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  };
  const items = (commande.produits || []).map(p => `
    <div class="row">
      <span>${p.qty > 1 ? `\u00d7${p.qty} ` : ''}${esc(p.name)}${p.note ? `<br><small style="color:#555">\u270e ${esc(p.note)}</small>` : ''}</span>
      <span style="white-space:nowrap;padding-left:8px">${fmtP(p.price * p.qty)}</span>
    </div>`).join('');
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><style>
    *{margin:0;padding:0;box-sizing:border-box}
    body{font-family:monospace;font-size:13px;width:72mm;padding:4mm}
    h1{text-align:center;font-size:17px;margin-bottom:3px}
    .c{text-align:center}.sep{border-top:1px dashed #000;margin:6px 0}
    .dsep{border-top:2px solid #000;margin:6px 0}
    .row{display:flex;justify-content:space-between;margin:3px 0}
    .tot{font-size:14px;font-weight:bold}
    .btn{display:block;width:100%;margin-top:12px;padding:12px;background:#C10230;color:#fff;border:none;border-radius:8px;font-size:15px;cursor:pointer}
    @media print{.btn{display:none}body{width:72mm}@page{size:80mm auto;margin:0}}
  </style></head><body>
    <h1>FOUR A TACOS</h1>
    <p class="c">303 Rue de la R\u00e9publique</p>
    <p class="c">73000 Chamb\u00e9ry</p>
    <div class="dsep"></div>
    <p><strong>COMMANDE #${esc(commande.numero)}</strong></p>
    <p>Client\u00a0: ${esc(commande.prenom)}${commande.telephone ? ' \u00b7 ' + esc(commande.telephone) : ''}</p>
    <p>Heure\u00a0: ${fmtH(commande.heure)}</p>
    ${commande.creneau ? `<p>Retrait\u00a0: ${esc(commande.creneau)}</p>` : ''}
    <div class="sep"></div>
    ${items}
    <div class="sep"></div>
    <div class="row tot"><span>TOTAL TTC</span><span>${fmtP(commande.total)}</span></div>
    <div class="dsep"></div>
    <p class="c" style="margin-top:8px">Merci et \u00e0 bient\u00f4t !</p>
    <button class="btn" onclick="window.print()">Imprimer</button>
  </body></html>`;
  const win = window.open('', '_blank', 'width=400,height=600');
  if (!win) return;
  win.document.write(html);
  win.document.close();
}

const fmt = (n) => Number(n).toFixed(2).replace('.', ',') + ' €';

const fmtHeure = (ts) => {
  if (!ts) return '—';
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
};

function playAlert() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const beep = (freq, start, duration) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.frequency.value = freq;
      osc.type = 'sine';
      gain.gain.setValueAtTime(0.5, ctx.currentTime + start);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + start + duration);
      osc.start(ctx.currentTime + start);
      osc.stop(ctx.currentTime + start + duration);
    };
    beep(880, 0, 0.15);
    beep(1100, 0.18, 0.15);
    beep(880, 0.36, 0.15);
    beep(1100, 0.54, 0.3);
  } catch (e) {
    console.warn('Audio non disponible', e);
  }
}

function NouvelleCommandePopup({ commande, onAccepter }) {
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      backgroundColor: 'rgba(0,0,0,0.85)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      animation: 'fadeIn 0.3s ease',
    }}>
      <div style={{
        backgroundColor: '#1A1A1A',
        border: '2px solid #C10230',
        borderRadius: '24px',
        padding: '48px 40px',
        textAlign: 'center',
        maxWidth: '460px',
        width: '90%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '24px',
        boxShadow: '0 0 60px rgba(139,31,63,0.4)',
        animation: 'popIn 0.3s ease',
      }}>
        {/* Indicateur clignotant */}
        <div style={{
          width: '16px', height: '16px', borderRadius: '50%',
          backgroundColor: '#C10230',
          animation: 'blink 0.8s ease infinite',
        }} />

        <div>
          <p style={{ fontFamily: 'Code Pro Black, sans-serif', fontSize: '42px', fontWeight: '400', color: '#fff', margin: '0 0 4px 0', letterSpacing: '3px', textTransform: 'uppercase' }}>
            Nouvelle commande !
          </p>
          <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '15px', color: '#888', margin: 0 }}>
            Reçue à {fmtHeure(commande.heure)}
          </p>
        </div>

        {/* Numéro + prénom */}
        <div style={{ backgroundColor: '#2A2A2A', borderRadius: '16px', padding: '20px 40px', width: '100%', boxSizing: 'border-box' }}>
          <p style={{ fontFamily: 'Code Pro Black, sans-serif', fontSize: '64px', fontWeight: '400', color: '#C10230', margin: 0, lineHeight: 1 }}>
            #{commande.numero}
          </p>
          <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '20px', fontWeight: '700', color: '#fff', margin: '8px 0 0 0' }}>
            {commande.prenom}
          </p>
          {commande.telephone && (
            <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '15px', color: '#ccc', margin: '2px 0 0 0' }}>
              {commande.telephone}
            </p>
          )}
          <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '14px', color: '#888', margin: '4px 0 0 0' }}>
            {fmt(commande.total)} · {(commande.produits || []).length} article{(commande.produits || []).length > 1 ? 's' : ''}
          </p>
        </div>

        {/* Boutons */}
        <div style={{ display: 'flex', gap: '12px', width: '100%' }}>
          <button
            onClick={onAccepter}
            style={{
              flex: 2,
              fontFamily: 'Jane Light, sans-serif',
              fontSize: '14px',
              fontWeight: '700',
              color: '#fff',
              backgroundColor: '#C10230',
              border: 'none',
              borderRadius: '12px',
              padding: '18px',
              cursor: 'pointer',
              textTransform: 'uppercase',
              letterSpacing: '1px',
            }}
          >
            ✓ Accepter
          </button>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
        @keyframes popIn { from { transform: scale(0.85); opacity: 0 } to { transform: scale(1); opacity: 1 } }
        @keyframes blink { 0%, 100% { opacity: 1 } 50% { opacity: 0 } }
      `}</style>
    </div>
  );
}

function ConfirmRefundModal({ onConfirm, onCancel, loading, error }) {
  return (
    <div
      style={{ position: 'fixed', inset: 0, zIndex: 9998, backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}
      onClick={onCancel}
    >
      <div
        style={{ backgroundColor: '#2A2A2A', border: '2px solid #C10230', borderRadius: '20px', padding: '36px 32px', maxWidth: '400px', width: '100%', textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '24px' }}
        onClick={e => e.stopPropagation()}
      >
        <p style={{ fontFamily: 'Code Pro Black, sans-serif', fontSize: '20px', color: '#fff', margin: 0, textTransform: 'uppercase', letterSpacing: '1px' }}>
          Confirmer l'annulation
        </p>
        <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '15px', color: '#aaa', margin: 0, lineHeight: '1.6' }}>
          Êtes-vous sûr de vouloir annuler et rembourser cette commande ?
        </p>
        {error && (
          <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '13px', color: '#C10230', margin: 0, lineHeight: '1.5' }}>
            ⚠ {error}
          </p>
        )}
        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            onClick={onCancel}
            disabled={loading}
            style={{ flex: 1, fontFamily: 'Jane Light, sans-serif', fontSize: '13px', fontWeight: '700', color: '#fff', backgroundColor: '#3A3A3A', border: 'none', borderRadius: '10px', padding: '14px', cursor: 'pointer', textTransform: 'uppercase' }}
          >
            Annuler
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            style={{ flex: 1, fontFamily: 'Jane Light, sans-serif', fontSize: '13px', fontWeight: '700', color: '#fff', backgroundColor: '#C10230', border: 'none', borderRadius: '10px', padding: '14px', cursor: loading ? 'not-allowed' : 'pointer', textTransform: 'uppercase', opacity: loading ? 0.6 : 1 }}
          >
            {loading ? 'En cours…' : 'Confirmer'}
          </button>
        </div>
      </div>
    </div>
  );
}

function CommandeCard({ commande }) {
  const [loading, setLoading] = useState(false);
  const [refundConfirm, setRefundConfirm] = useState(false);
  const [refunding, setRefunding] = useState(false);
  const [refundError, setRefundError] = useState('');
  const [printing, setPrinting] = useState(false);
  const [printError, setPrintError] = useState('');

  const handlePrint = () => {
    setPrinting(true);
    setPrintError('');
    try {
      printCommandeWeb(commande);
    } catch (e) {
      console.error('Erreur impression:', e);
      setPrintError('Imprimante non disponible');
    }
    setPrinting(false);
  };

  const changeStatut = async (statut) => {
    setLoading(true);
    try {
      await updateDoc(doc(db, 'commandes', commande.id), { statut });
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  const handleRefund = async () => {
    setRefunding(true);
    setRefundError('');
    try {
      if (!commande.stripePaymentId) {
        setRefundError('Identifiant de paiement manquant — remboursez manuellement sur Stripe.');
        setRefunding(false);
        return;
      }
      const refundPayment = httpsCallable(functions, 'refundPayment');
      await refundPayment({ paymentIntentId: commande.stripePaymentId });
      await updateDoc(doc(db, 'commandes', commande.id), { statut: 'annulée' });
      setRefundConfirm(false);
    } catch (e) {
      console.error('Refund error:', e);
      setRefundError('Erreur lors du remboursement. Vérifiez Stripe.');
    }
    setRefunding(false);
  };

  const isEnPrep = commande.statut === 'en préparation';
  const canRefund = commande.statut === 'payée' || commande.statut === 'payee' || commande.statut === 'en préparation';

  return (
    <div style={{
      backgroundColor: '#2A2A2A',
      borderRadius: '16px',
      padding: '24px',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      border: isEnPrep ? '2px solid #888888' : '2px solid #3A3A3A',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <div style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '32px', fontWeight: '800', color: '#fff', lineHeight: 1 }}>
            #{commande.numero}
          </div>
          <div style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '16px', fontWeight: '600', color: '#ccc', marginTop: '4px' }}>
            {commande.prenom}{commande.telephone ? ` · ${commande.telephone}` : ''}
          </div>
          {commande.creneau && (
            <div style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '13px', color: '#C10230', fontWeight: '700', marginTop: '4px' }}>
              Récupération : {commande.creneau}
            </div>
          )}
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '13px', color: '#888' }}>
            {fmtHeure(commande.heure)}
          </div>
          <div style={{
            marginTop: '6px', display: 'inline-block', padding: '3px 10px',
            borderRadius: '20px', fontFamily: 'Jane Light, sans-serif', fontSize: '11px',
            fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px',
            backgroundColor: isEnPrep ? '#888888' : '#C10230', color: '#fff',
          }}>
            {commande.statut}
          </div>
        </div>
      </div>

      <div style={{ borderTop: '1px solid #3A3A3A', paddingTop: '14px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
        {(commande.produits || []).map((p, i) => (
          <div key={i}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '13px', color: '#ddd', flex: 1, paddingRight: '12px' }}>
                {p.qty > 1 && <span style={{ fontWeight: '700', color: '#fff', marginRight: '6px' }}>×{p.qty}</span>}
                {p.name}
              </div>
              <div style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '13px', fontWeight: '600', color: '#aaa', flexShrink: 0 }}>
                {fmt(p.price * p.qty)}
              </div>
            </div>
            {p.note && (
              <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '11px', color: '#888888', margin: '3px 0 0 0', fontStyle: 'italic' }}>
                ✎ {p.note}
              </p>
            )}
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #3A3A3A', paddingTop: '12px' }}>
        <span style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '14px', fontWeight: '600', color: '#888' }}>Total TTC</span>
        <span style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '22px', fontWeight: '800', color: '#fff' }}>{fmt(commande.total)}</span>
      </div>

      <div style={{ display: 'flex', gap: '10px' }}>
        <button
          onClick={() => changeStatut('en préparation')}
          disabled={loading || isEnPrep}
          style={{ flex: 1, fontFamily: 'Jane Light, sans-serif', fontSize: '13px', fontWeight: '700', color: '#fff', backgroundColor: isEnPrep ? '#555' : '#C10230', border: 'none', borderRadius: '10px', padding: '14px 10px', cursor: isEnPrep || loading ? 'not-allowed' : 'pointer', textTransform: 'uppercase', letterSpacing: '0.5px', opacity: isEnPrep ? 0.5 : 1 }}
        >
          En préparation
        </button>
        <button
          onClick={() => changeStatut('prête')}
          disabled={loading}
          style={{ flex: 1, fontFamily: 'Jane Light, sans-serif', fontSize: '13px', fontWeight: '700', color: '#fff', backgroundColor: '#C10230', border: 'none', borderRadius: '10px', padding: '14px 10px', cursor: loading ? 'not-allowed' : 'pointer', textTransform: 'uppercase', letterSpacing: '0.5px' }}
        >
          ✓ Prête
        </button>
      </div>

      <button
        onClick={handlePrint}
        disabled={printing}
        style={{ width: '100%', fontFamily: 'Jane Light, sans-serif', fontSize: '13px', fontWeight: '700', color: '#fff', backgroundColor: '#2A5298', border: 'none', borderRadius: '10px', padding: '12px', cursor: printing ? 'not-allowed' : 'pointer', textTransform: 'uppercase', letterSpacing: '0.5px', opacity: printing ? 0.7 : 1 }}
      >
        {printing ? 'Impression...' : '🖨 Imprimer le ticket'}
      </button>

      {printError && (
        <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '12px', color: '#C10230', margin: 0, textAlign: 'center' }}>{printError}</p>
      )}

      {canRefund && (
        <button
          onClick={() => setRefundConfirm(true)}
          disabled={loading || refunding}
          style={{ width: '100%', fontFamily: 'Jane Light, sans-serif', fontSize: '12px', fontWeight: '700', color: '#888', backgroundColor: 'transparent', border: '1px solid #3A3A3A', borderRadius: '10px', padding: '10px', cursor: 'pointer', textTransform: 'uppercase', letterSpacing: '0.5px' }}
        >
          Annuler et rembourser
        </button>
      )}

      {refundConfirm && (
        <ConfirmRefundModal
          onConfirm={handleRefund}
          onCancel={() => { setRefundConfirm(false); setRefundError(''); }}
          loading={refunding}
          error={refundError}
        />
      )}
    </div>
  );
}

function LoginScreen({ onSuccess }) {
  const [pwd, setPwd] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await setPersistence(firebaseAuth, browserLocalPersistence);
      await signInWithEmailAndPassword(firebaseAuth, 'tablette@fouratacos.fr', pwd);
      localStorage.setItem('tablette_login_time', Date.now().toString());
      onSuccess();
    } catch (err) {
      console.error('[Tablette login]', err.code, err.message);
      setError(err.code || 'erreur inconnue');
      setPwd('');
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#1A1A1A', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '24px', width: '100%', maxWidth: '320px' }}>
        <img src="/logo.svg" alt="Four A Tacos" style={{ width: '100px', marginBottom: '8px' }} />
        <input
          type="password"
          value={pwd}
          onChange={(e) => { setPwd(e.target.value); setError(''); }}
          placeholder="Mot de passe"
          style={{ width: '100%', padding: '14px 18px', borderRadius: '10px', border: error ? '2px solid #C10230' : '2px solid #444', backgroundColor: '#2A2A2A', color: '#fff', fontFamily: 'Jane Light, sans-serif', fontSize: '16px', outline: 'none', boxSizing: 'border-box' }}
        />
        {error && (
          <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '13px', color: '#C10230', margin: '-12px 0 0 0', textAlign: 'center' }}>
            {error}
          </p>
        )}
        <button type="submit" disabled={loading} style={{ width: '100%', padding: '14px', borderRadius: '10px', border: 'none', backgroundColor: '#8B1F3F', color: '#fff', fontFamily: 'Code Pro Black, sans-serif', fontSize: '18px', fontWeight: '400', letterSpacing: '2px', textTransform: 'uppercase', cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}>
          {loading ? '...' : 'Accéder'}
        </button>
      </form>
    </div>
  );
}

export default function Tablette() {
  const [auth, setAuth] = useState(false);
  const [authLoading, setAuthLoading] = useState(true);
  const [commandes, setCommandes] = useState([]);
  const [alertQueue, setAlertQueue] = useState([]);
  const seenIds = useRef(null);

  useEffect(() => {
    const unsub = firebaseAuth.onAuthStateChanged(async (user) => {
      if (user) {
        let loginTime = parseInt(localStorage.getItem('tablette_login_time') || '0', 10);
        if (loginTime === 0) {
          loginTime = Date.now();
          localStorage.setItem('tablette_login_time', loginTime.toString());
        }
        const expired = Date.now() - loginTime > 24 * 60 * 60 * 1000;
        if (expired) {
          await firebaseAuth.signOut();
          localStorage.removeItem('tablette_login_time');
          setAuth(false);
        } else {
          setAuth(true);
        }
      } else {
        setAuth(false);
      }
      setAuthLoading(false);
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    if (!auth) return;
    const q = query(
      collection(db, 'commandes'),
      where('statut', 'in', ['payée', 'payee', 'en préparation']),
      orderBy('heure', 'desc')
    );

    const unsub = onSnapshot(q, (snap) => {
      const docs = snap.docs.map((d) => ({ id: d.id, ...d.data() }));

      if (seenIds.current === null) {
        // Premier chargement — on mémorise sans déclencher d'alerte
        seenIds.current = new Set(docs.map((d) => d.id));
      } else {
        // Détecte les nouvelles commandes avec statut "payée"
        const nouvelles = docs.filter(
          (d) => !seenIds.current.has(d.id) && (d.statut === 'payée' || d.statut === 'payee')
        );
        if (nouvelles.length > 0) {
          playAlert();
          setAlertQueue((prev) => [...prev, ...nouvelles]);
        }
        docs.forEach((d) => seenIds.current.add(d.id));
      }

      setCommandes(docs);
    }, (err) => {
      console.error('[Tablette] Firestore error:', err);
    });

    return () => unsub();
  }, [auth]);

  if (authLoading) return null;
  if (!auth) return <LoginScreen onSuccess={() => setAuth(true)} />;

  const commandeEnAlerte = alertQueue[0] || null;

  const sortByCreneau = (a, b) => {
    if (!a.creneau && !b.creneau) return 0;
    if (!a.creneau) return 1;
    if (!b.creneau) return -1;
    return a.creneau.localeCompare(b.creneau);
  };

  const handleAccepter = async () => {
    if (!commandeEnAlerte) return;
    try {
      await updateDoc(doc(db, 'commandes', commandeEnAlerte.id), { statut: 'en préparation' });
    } catch (e) {
      console.error(e);
    }
    setAlertQueue((prev) => prev.slice(1));
  };

  const nouvelles = commandes.filter(c => c.statut === 'payée' || c.statut === 'payee').sort(sortByCreneau);
  const enPrep = commandes.filter(c => c.statut === 'en préparation').sort(sortByCreneau);
  const total = nouvelles.length + enPrep.length;

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#1A1A1A', padding: '24px' }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>

        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '28px', flexWrap: 'wrap', gap: '12px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <h1 style={{ fontFamily: 'Code Pro Black, sans-serif', fontSize: 'clamp(18px, 3vw, 28px)', fontWeight: '400', color: '#fff', margin: 0, textTransform: 'uppercase', letterSpacing: '2px' }}>
              Commandes
            </h1>
            {total > 0 && (
              <span style={{ backgroundColor: '#C10230', color: '#fff', fontFamily: 'Jane Light, sans-serif', fontSize: '14px', fontWeight: '700', borderRadius: '20px', padding: '3px 12px' }}>
                {total} en cours
              </span>
            )}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <div style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '13px', color: '#666', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#C10230', display: 'inline-block', animation: 'pulse 2s infinite' }} />
              En direct
            </div>
            <button onClick={() => { firebaseAuth.signOut(); setAuth(false); }} style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '12px', color: '#555', background: 'none', border: '1px solid #333', borderRadius: '6px', padding: '6px 12px', cursor: 'pointer', whiteSpace: 'nowrap' }}>
              Se déconnecter
            </button>
          </div>
        </div>

        {total === 0 ? (
          <div style={{ textAlign: 'center', paddingTop: '80px' }}>
            <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '18px', color: '#555' }}>
              Aucune commande en cours
            </p>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>

            {/* Nouvelles commandes */}
            {nouvelles.length > 0 && (
              <section>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
                  <span style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#C10230', display: 'inline-block', animation: 'pulse 0.8s ease infinite' }} />
                  <h2 style={{ fontFamily: 'Code Pro Black, sans-serif', fontSize: '13px', fontWeight: '400', color: '#C10230', margin: 0, textTransform: 'uppercase', letterSpacing: '2px' }}>
                    Nouvelles — {nouvelles.length}
                  </h2>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(min(300px, 100%), 1fr))', gap: '16px' }}>
                  {nouvelles.map(c => <CommandeCard key={c.id} commande={c} />)}
                </div>
              </section>
            )}

            {/* En préparation */}
            {enPrep.length > 0 && (
              <section>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
                  <h2 style={{ fontFamily: 'Code Pro Black, sans-serif', fontSize: '13px', fontWeight: '400', color: '#888', margin: 0, textTransform: 'uppercase', letterSpacing: '2px' }}>
                    En préparation — {enPrep.length}
                  </h2>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(min(300px, 100%), 1fr))', gap: '16px' }}>
                  {enPrep.map(c => <CommandeCard key={c.id} commande={c} />)}
                </div>
              </section>
            )}

          </div>
        )}
      </div>

      {commandeEnAlerte && (
        <NouvelleCommandePopup
          commande={commandeEnAlerte}
          onAccepter={handleAccepter}
        />
      )}

      <style>{`
        @keyframes pulse { 0%, 100% { opacity: 1 } 50% { opacity: 0.3 } }
      `}</style>
    </div>
  );
}
